import { render } from "./ButtonRow.vue?vue&type=template&id=81178c76&scoped=true"
import script from "./ButtonRow.vue?vue&type=script&lang=js"
export * from "./ButtonRow.vue?vue&type=script&lang=js"

import "./ButtonRow.vue?vue&type=style&index=0&id=81178c76&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/soilfood.com/soilfood.com/vue/oma-myyja/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81178c76"]])

export default __exports__